<h1>Nuevo ingreso</h1>
<section class="announcement-invoice">
  <div class="announcement-invoice-company">
    <div class="announcement-invoice-company-name">
      <p>Empresa pagadora</p>
      <h3>{{data?.invoice?.debtor?.companyName}}</h3>
    </div>
    <div class="announcement-invoice-company-amount">
      <p>Monto de la factura</p>
      <lib-amount color="blue" [amount]="data?.invoice?.netAmount || '0.00'"></lib-amount>
    </div>
  </div>
  <div class="announcement-invoice-detail">
    <div class="announcement-invoice-detail-codes">
      <p>Códigos ({{getInvoiceCodesCount(data?.invoice)}})</p>
      <span>{{getInvoiceCodes(data?.invoice)}}</span>
    </div>
    <lib-chip-status [status]="data?.invoice?.status"></lib-chip-status>
  </div>
  <div class="announcement-invoice-finalized-card" *ngIf="data?.invoice?.status === 'finalized'">
    <lib-icon icon="info" size="s" color="red"></lib-icon>
    <div class="announcement-invoice-finalized-card-content">
        <p>Es una factura finalizada</p>
        <span>
          Recuerda que estas comunicaciones deben ser bien puntuales y validadas con
          el líder comercial.
        </span>
    </div>
  </div>
</section>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="controls">
    <ng-container>
      <div class="comment-container">
        <h6>Registra la actualización</h6>
        <div class="previewBox">
          <angular-editor
            formControlName="message"
            [config]="editorConfig"
            [(ngModel)]="message"
          ></angular-editor>
        </div>
        <mat-hint
          *ngIf="
            form.controls.message?.touched && form.controls.message?.invalid
          "
        >
          <p class="custom-mat-invalid-style">Obligatorio</p>
        </mat-hint>
      </div>
      <div class="intercom-button-upload">
        <app-upload
          formControlName="file"
          [default]="data?.announcementDetail?.file"
          [getFileName]="true"
          (fileNameLoaded)="setFileName($event)"
          initialLabel="Adjuntar archivo"
          loadedLabel="Archivo cargado"
        ></app-upload>
      </div>
    </ng-container>
  </div>

  <div class="button-container button-direction-column">
    <fs-ui-button
      [action]="'submit'"
      (click)="onSubmit()"
      [label]="'Siguiente'"
    ></fs-ui-button>
    <fs-ui-button
      (click)="cancel()"
      [label]="'Cancelar'"
      [type]="'tertiary'"
    ></fs-ui-button>
  </div>
</form>
